
<template>
  <div>
    <div class="ipub-h1 mar-b-12">Manuscript No. {{detail.code}}</div>
    <div class="ipub-block mar-b-30">
      <div class="flex mar-b-16 ipub-p2">
        <strong class="ipub-block__span">Article Type</strong>
        <span class="ipub-block__font">{{detail.type && detail.type.name||'--'}}</span>
      </div>
      <div class="flex mar-b-16 ipub-p2">
        <strong class="ipub-block__span">Journal</strong>
        <span class="ipub-block__font">{{detail.journal&&detail.journal.fullName||'--'}}</span>
      </div>
      <div class="flex mar-b-16 ipub-p2">
        <strong class="ipub-block__span">Article Title</strong>
        <span class="ipub-block__font">{{detail.title||'--'}}</span>
      </div>
      <div class="flex ipub-p2">
        <strong class="ipub-block__span">Abstract</strong>
        <div class="ipub-block__font"
             v-html="detail.summary && detail.summary.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')||'--'"></div>
      </div>
    </div>
    <div class="mar-b-16 ipubw-p2">If you accept the invitation, we would appreciate receiving your comments by <strong>{{detail.reviewDueDay}}</strong> days</div>
    <ipub-form ref="review-confirm-form"
               :model="form"
               :rules="rules"
               class="review-confirm-form">
      <ipub-form-item prop="turnstileToken"
                      label="Verification Code">
        <div class="captcha-wrap">
          <ipub-input v-model.trim="form.turnstileToken"
                      placeholder="Verification Code"
                      class="captcha-input"
                      @keyup.enter.native="submit" />
          <img v-if="captcha.codeImage"
               :src="captcha.codeImage"
               @click="getCaptcha"
               class="captcha-image ipub-c-p"
               title="Click to refresh"
               alt="Verification Code">
        </div>
      </ipub-form-item>
    </ipub-form>
    <div>
      <ipub-button plain
                    type="primary"
                    @click="cancel">Cancel</ipub-button>
      <ipub-button class="mar-b-20"
                    type="primary"
                    :loading="submitting"
                    @click="submit">Accept to review this manuscript</ipub-button>
    </div>

  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
.part {
  background: $content_color;
  padding: 24px 36px 36px;
}
.review-confirm-form {
  max-width: 520px;
}
.captcha-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.captcha-input {
  flex: 1;
}
.captcha-image {
  width: 160px;
  height: 40px;
  border: 1px solid #e9eef0;
  border-radius: 4px;
}
</style>
